import styled, { css } from 'styled-components';
import background from '../../../assets/images/background.png'

export const Container = styled.div`
    width: 100vw;
    background-color: #000;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const StyledRow = styled.div`
    ${props => props.backgroundColor && css`
        background-color: ${props.backgroundColor}
    `};
    ${props => props.height && css`
        height: ${props.height}
    `};
    width: 100%;
    display: ${props => !props.show ? 'none' : 'flex'};
    flex-direction: column;
    align-items: center;
    ${props => props.showBg !== false  && css`
        background-image: url(${background});
    `};
    background-size: cover;
    background-repeat: no-repeat;
    padding-bottom: 3em;
    margin-top: ${props => props.marginTop};

    h2 {
        text-align: center;
        margin: 0 0 1em 0;
        font: italic bold 36px "Roboto";
    }

    /* h1 {
        text-align: center;
        font: italic bold 28px "Roboto Condensed";
        width: 100%;
    } */

    h1.package-heading {
        text-align: center;
        margin: .5em 0 .5em 0;
        font: italic bold 28px "Roboto Condensed";
        width: 100%;
        text-transform: uppercase;

        span {
            color: #acff24;
            font-size: 28px;
        }
    }
    button {height: 40px; padding: 0 2em; width: 200px;}

    // h1.package-heading {margin-top: 2em;}

    svg {
        width: 90%;
        height: 90%;
    }

    div.toggle-plan-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        width: 400px;
        justify-content: space-around;
        margin-top: 2em;

        p {
            color: #fff;
            font: bold normal 24px 'Roboto';
        }
    }
`

export const SectionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: ${props => props.width ? props.width : '80%'};
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-top: 5em;

    div:first-child {
        padding-left: 3em;
        padding-right: 1em;
    }
`

export const FeaturesContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 80%;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
`

export const HeaderCol = styled.div`
    display: flex;
    flex-direction:column;
    align-items: flex-start;
    width: ${props => props.width ? props.width : '50%' };
    height: 360px;
    background-color: ${props => props.background ? props.background : 'transparent'};
    justify-content: center;

    h1 {
        font: italic bold 36px 'Roboto Condensed';
        color: #fff;
        text-align: left;

        span{color: #acff24;}
    }
    img{
        /* width: 100%; */
        height: 100%;
        overflow: hidden;
    }

    button.get-plex {
        margin-top: 1em;
    }

    p {
        span {color: #acff24; font-weight: bold;}
    }
`

export const FeatureWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #2d2d2d;
    width: 360px;
    height: 430px;
    min-height: 310px;
    padding: 24px 8px;
    border-radius: 2px;

    div.icon-wrap {
        width: 100%;
        padding: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .feature-thumbnail {
            height: 240px;    
        }
    }
    h3, p {text-align: center;}
    h3.feature-name {font: italic bold 20px "Roboto Condensed" !important; margin-top: .75em;}
    p.feature-description {font-size: 15px !important;}
    button.play-feature {
        width: 160px;

        span > i {
            font-size: 20px;
        }
    }
`
export const VideosContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 70%;
    align-items: center;
    justify-content: center;
    padding-bottom: 1em;
`
export const UpgradeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 540px;
    // background-color: #1a1a1a;
    border-radius: 5px;
    box-shadow: 0px 3px 10px 6px rgba(0,0,0,0.75);
    margin-top: 6em;
    margin-bottom: 5em;
    padding: 1em 2em 2em 2em;

    div.upgrade-header, div.feature-list {
        width: 100%;
        border-bottom: solid #fff 1px;
        display: inherit;
        align-items: flex-start;
        flex-direction: column;
    }
    div.feature-list {padding: 1.5em 0; margin-bottom: 2em;}

    .upgrade-header img {width: 180px;}

    & button {
        width: 100%;
        height: 45px;
    }
`

export const CheckoutSummary = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background-color: #2d2d2d;
    padding-top: 12px;
    border-radius: 2px;
    text-transform: uppercase;
    width: 100%;

    h2.order-heading {
        font: italic bold 22px 'Roboto Condensed';
        text-align: left;
        text-transform: uppercase;
    }
    div.order-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 90%;

        img {height: 40px; width: auto;}
        p.checkout-name {font: italic bold 18px 'Roboto Condensed'; margin: 0 !important;}
    }

    hr {border-top: 1px solid #999; width: 95%;}

    div.order-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 90%;

        p.order-detail, p.order-value {
            font: italic bold 18px 'Roboto Condensed';
        }
        p.order-value {color: #acff24;}
    }
`
export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    padding: 20px;
`

export const F1Container = styled.div`
    width: 80%;
    height: 500px;
    position: relative;

    div.f1-container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .overlay-top {
        z-index: 10;
        background-color: #00000090;
        display: ${props => props.showOverlay ? 'flex' : 'none'};
        align-items: center;
        justify-content: center;

        button.view-f1 {padding: 0 1.5em; height: 45px;}
    }
`
export const PaymentModalRow = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    div.modal-right {
        width: 30%;
        min-width: 200px;
        color: #fff;
        padding: 30px 20px 20px 0;

        h2.order-header {
            font: italic bold 18px 'Roboto Condensed';
            text-transform: uppercase;
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/Onboard/PrePayment/PrePayment.styles.ts